import classNames from 'classnames';
import ReactPaginate from 'react-paginate';
import type { ReactPaginateProps } from 'react-paginate';

import styles from './_index.module.scss';

export interface PaginationProps extends ReactPaginateProps {
  'data-testid'?: string;
  nextLabel?: string;
  onPageChange?: () => void;
  pageCount: number;
  pageRangeDisplayed?: number;
  previousLabel?: string;
  show?: boolean;
  variant?: 'default' | 'dots';
}

function Pagination({
  className,
  'data-testid': dataTestId,
  marginPagesDisplayed = 1,
  nextLabel = 'Next >',
  onPageChange,
  pageCount,
  pageRangeDisplayed = 5,
  previousLabel = '< Prev',
  show,
  variant = 'default',
  ...other
}: PaginationProps) {
  if (!show) {
    return null;
  }
  const isDotsVariant = variant === 'dots';
  const visiblePageSlots = Math.min(pageCount, pageRangeDisplayed + marginPagesDisplayed * 2);
  const shouldClampWidth = visiblePageSlots >= 7;

  return (
    <div data-testid={dataTestId}>
      <ReactPaginate
        activeClassName={styles['pagination-active']}
        breakLabel="..."
        className={classNames(styles['pagination'], className, {
          [styles['pagination-dots']]: isDotsVariant,
          [styles['pagination-clamped']]: shouldClampWidth,
        })}
        disabledClassName={styles['pagination-disabled']}
        marginPagesDisplayed={marginPagesDisplayed}
        nextLabel={isDotsVariant ? '→' : nextLabel}
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageLinkClassName={isDotsVariant ? styles['page-dot'] : undefined}
        pageRangeDisplayed={pageRangeDisplayed}
        previousLabel={isDotsVariant ? '←' : previousLabel}
        renderOnZeroPageCount={null}
        {...other}
      />
    </div>
  );
}

export default Pagination;
